export default __webpack_public_path__ + "static/media/rectangle.c433dbf8.svg";